// extracted by mini-css-extract-plugin
module.exports = {"container":"hit-result-counts_container__hrRyI","hitCounts":"hit-result-counts_hitCounts__4QN7Z","fade-in":"hit-result-counts_fade-in__PJ9ZJ"};